// Shared academic-year helpers.
//
// Single source of truth for the academic-year option list + the "current" year,
// replacing the copies that were hardcoded/duplicated across the fee pages
// (student FeeStructure, admin FeeReceipts/PaymentHistory/PendingPayments*/
// ManualPaymentsHistory, UnifiedReceiptViewer) and the private buildAcademicYears()
// that used to live in panel/FeeStructures.jsx.
//
// Format is "YYYY-YY" (e.g. "2026-27") to match the strings stored in
// FeeStructure.academicYear and payment.academicYear.

/**
 * Build the academic-year option list: a wide window from a couple of years ahead
 * (to set up the upcoming intake) back through several years (for historical/edit
 * access). Newest first.
 * @param {{ahead?: number, back?: number}} [opts]
 * @returns {string[]} e.g. ["2028-29", "2027-28", ..., "2021-22"]
 */
export const buildAcademicYears = ({ ahead = 2, back = 5 } = {}) => {
  const nowYear = new Date().getFullYear();
  const startFrom = nowYear + ahead; // furthest future first (newest on top)
  const years = [];
  for (let y = startFrom; y >= nowYear - back; y--) {
    years.push(`${y}-${String((y + 1) % 100).padStart(2, "0")}`);
  }
  return years;
};

/**
 * The current academic year in "YYYY-YY" form, derived from today's calendar year.
 * @returns {string} e.g. "2026-27"
 */
export const getCurrentAcademicYear = () => {
  const y = new Date().getFullYear();
  return `${y}-${String((y + 1) % 100).padStart(2, "0")}`;
};

// Convenience constant for callers that just want "the list" (evaluated at import).
export const ACADEMIC_YEARS = buildAcademicYears();
